import { i18n } from "@/locales/i18n";

export const EStickerTypeValue = {
  YEARLY_N: `${i18n.tc("STICKER_CARD_LABEL.YEARLY_N")}`,
  YEARLY_C: `${i18n.tc("STICKER_CARD_LABEL.YEARLY_C")}`,
  MONTHLY_N: `${i18n.tc("STICKER_CARD_LABEL.MONTHLY_N")}`,
  _10DAYS_N: `${i18n.tc("STICKER_CARD_LABEL._10DAYS_N")}`,
  ONEDAY_N: `${i18n.tc("STICKER_CARD_LABEL.ONEDAY_N")}`,
  YEARLY_M1: `${i18n.tc("STICKER_CARD_LABEL.YEARLY_M1")}`,
  YEARLY_D1CS: `${i18n.tc("STICKER_CARD_LABEL.YEARLY_D1CS")}`,
};

export enum EStickerType {
  YEARLY_N = "YEARLY_N",
  YEARLY_C = "YEARLY_C",
  MONTHLY_N = "MONTHLY_N",
  _10DAYS_N = "_10DAYS_N",
  ONEDAY_N = "ONEDAY_N",
  YEARLY_M1 = "YEARLY_M1",
  YEARLY_D1CS = "YEARLY_D1CS",
}
